import type { Element } from "React";
import { Component } from "react";
import "./ProgressBar.scss";
type Props = {
  color?: string;
  completed?: boolean;
  isLoading: boolean;
};
type State = {
  forceCompleted: number;
};

class ProgressBar extends Component<Props, State> {
  filler: any;
  intervalId: IntervalID;

  constructor(props: Props) {
    super(props);
    this.state = {
      forceCompleted: 0,
    };
  }

  componentDidMount() {
    this.startAnimation();
  }

  componentWillUnmount: () => void = () => {
    clearInterval(this.intervalId);
  };

  startAnimation() {
    const defaultIncrement = 5;
    let increment = !this.props.isLoading ? 100 : defaultIncrement;
    this.setState({
      forceCompleted: increment,
    });
    increment += defaultIncrement;
    this.intervalId = setInterval(() => {
      if (increment > 100 || !this.props.isLoading) {
        clearInterval(this.intervalId);
      } else {
        this.setState({
          forceCompleted: increment,
        });
        increment += defaultIncrement;
      }
    }, 500);
  }

  render(): Element<"div"> {
    const { completed } = this.props;
    const fillerStyles = {
      width: `${this.state.forceCompleted}%`,
    };
    return (
      <div className="container-styles">
        <div
          ref={ref => (this.filler = ref)}
          className="filler-styles"
          style={fillerStyles}
        >
          <span className="label-styles">{`${
            // note: prop completed is always seems to be set to undefined?
            completed ? "" : this.state.forceCompleted
          }%`}</span>
        </div>
      </div>
    );
  }
}

export default ProgressBar;
